import { Component, Input, output } from '@angular/core';
import { HighchartsChartComponent } from 'highcharts-angular';
import type Highcharts from 'highcharts/esm/highcharts';

@Component({
  selector: 'app-chart',
  templateUrl: './chart.component.html',
  styleUrls: ['./chart.component.scss'],
  standalone: true,
  imports: [HighchartsChartComponent],
})
export class ChartComponent {
  @Input() options!: Highcharts.Options;

  readonly optionsChange = output<Highcharts.Options>();
  readonly chartPrint = output<void>();
  readonly chartInstanceEvent = output<Highcharts.Chart>();

  chart?: Highcharts.Chart;

  onChartInstance(chart: Highcharts.Chart): void {
    this.chart = chart;
    this.chartInstanceEvent.emit(chart);
    setTimeout(() => this.chartPrint.emit(), 100);
  }
}
